module.exports = __webpack_public_path__ + "img/sidebar_fizzliga_202627.476bf34b.png";